<template>
  <a-spin :spinning="loading" class="c-box">
    <div class="spin-content">
      <div class="wrapper">
        <a-row :gutter="16">
          <a-col :span="14">
            <h2>
              {{ course.is_group ? 'Kurs grupowy' : 'Kurs indywidualny' }}
            </h2>

            <div>
              <icon-with-text icon="user">
                {{ course.lecturer_name }}
              </icon-with-text>

              <icon-with-text :component="StudentSvg">
                <span
                  v-for="(student, i) in course.students_name"
                  :key="i"
                  class="student-name"
                  >{{ student }}</span
                >
              </icon-with-text>

              <icon-with-text icon="clock-circle">
                {{ course.deadline }}
              </icon-with-text>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { Course } from '@/api'
import StudentSvg from '@/assets/student.svg'
import IconWithText from '@/components/common/IconWithText'

export default {
  components: {
    IconWithText
  },
  data() {
    return {
      StudentSvg,
      course: {},
      loading: false
    }
  },
  created() {
    this.fetchCourse()
  },
  methods: {
    async fetchCourse() {
      this.loading = true
      Course.get(this.$route.params.courseId)
        .then(res => {
          this.course = res.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.student-name {
  &:not(:last-child)::after {
    content: ', ';
  }
}
</style>
